export const LICENSE_PLATE_CODES = [
    "67", // An Giang
    "72", // Bà Rịa - Vũng Tàu
    "98", // Bắc Giang
    "97", // Bắc Kạn
    "94", // Bạc Liêu
    "99", // Bắc Ninh
    "71", // Bến Tre
    "77", // Bình Định
    "61", // Bình Dương
    "93", // Bình Phước
    "86", // Bình Thuận
    "69", // Cà Mau
    "65", // Cần Thơ
    "11", // Cao Bằng
    "43", // Đà Nẵng
    "47", // Đắk Lắk
    "48", // Đắk Nông
    "27", // Điện Biên
    "39", // Đồng Nai
    "66", // Đồng Tháp
    "81", // Gia Lai
    "23", // Hà Giang
    "90", // Hà Nam
    "29", // Hà Nội
    "30", // Hà Nội
    "31", // Hà Nội
    "32", // Hà Nội
    "33", // Hà Nội
    "40", // Hà Nội
    "38", // Hà Tĩnh
    "34", // Hải Dương
    "15", // Hải Phòng
    "16", // Hải Phòng
    "95", // Hậu Giang
    "28", // Hòa Bình
    "89", // Hưng Yên
    "79", // Khánh Hòa
    "68", // Kiên Giang
    "82", // Kon Tum
    "25", // Lai Châu
    "49", // Lâm Đồng
    "12", // Lạng Sơn
    "24", // Lào Cai
    "62", // Long An
    "18", // Nam Định
    "37", // Nghệ An
    "35", // Ninh Bình
    "85", // Ninh Thuận
    "19", // Phú Thọ
    "78", // Phú Yên
    "73", // Quảng Bình
    "92", // Quảng Nam
    "76", // Quảng Ngãi
    "14", // Quảng Ninh
    "74", // Quảng Trị
    "83", // Sóc Trăng
    "26", // Sơn La
    "70", // Tây Ninh
    "17", // Thái Bình
    "20", // Thái Nguyên
    "36", // Thanh Hóa
    "75", // Thừa Thiên - Huế
    "63", // Tiền Giang
    "41", // TP. Hồ Chí Minh
    "50", // TP. Hồ Chí Minh
    "51", // TP. Hồ Chí Minh
    "52", // TP. Hồ Chí Minh
    "53", // TP. Hồ Chí Minh
    "54", // TP. Hồ Chí Minh
    "55", // TP. Hồ Chí Minh
    "56", // TP. Hồ Chí Minh
    "57", // TP. Hồ Chí Minh
    "58", // TP. Hồ Chí Minh
    "59", // TP. Hồ Chí Minh
    "84", // Trà Vinh
    "22", // Tuyên Quang
    "64", // Vĩnh Long
    "88", // Vĩnh Phúc
    "21", // Yên Bái

    "60", // Đồng Nai
];

export const REGION_INDEX_TO_PROVINCE_INDEX = [
    [0], [1], [2], [3], [4], [5], [6], [7], [8], [9], [10], [11], [12], [13], [14], [15], [16], [17], [18, 79], [19],
    [20], [21], [22], [23, 24, 25, 26, 27, 28], [29], [30], [31, 32], [33], [34], [35], [36], [37],
    [38], [39], [40], [41], [42], [43], [44], [45], [46], [47], [48], [49], [50], [51], [52], [53], [54], [55],
    [56], [57], [58], [59], [60], [61], [62], [63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73], [74], [75], [76], [77], [78],
];
